import * as React from 'react';
import { Panel } from '../Panel';
import { ICONS } from '../../../assets/Icons';
import { AreaGraph } from '../Graphs/AreaGraph';
import { graphStyle } from '../../../assets/styles/Layout/AreaGraph';
import { CONSTANTS } from '../../../assets/UIConstants';
import { CurrentValue } from '../CurrentValue';
import { ValueDelta } from '../ValueDelta';
import {
    METABOLIC_RATE_INFO,
    METABOLIC_RATE_PANEL_TITLE,
    METABOLIC_RATE_POPOVER_TITLE
} from '../../../assets/ApplicationCopy';
import { AbstractPanel } from './AbstractPanel';
import { Scan } from '../../../data_layer/models/Scan';
import { FullSummaryCategories } from '../../pages/FullSummary';

const valueContainerStyle: React.CSSProperties = {
    display: CONSTANTS.DISPLAY.FLEX, 
    flexDirection: CONSTANTS.FLEX_DIRECTION.COLUMN, 
    flexGrow: CONSTANTS.FLEX_GROW.ONE, 
    justifyContent: CONSTANTS.FLEX_JUSTIFY.END, 
    alignItems: CONSTANTS.ALIGN_ITEMS.CENTER
};

export class BasalMetabolicRate extends AbstractPanel {
    protected panelId: string = FullSummaryCategories.BasalMetabolic;
    protected panelTitle: string = METABOLIC_RATE_PANEL_TITLE;
    protected popoverTitle: string = METABOLIC_RATE_POPOVER_TITLE;
    protected popoverBody: string | JSX.Element = METABOLIC_RATE_INFO;

    protected fullSummaryLinkPath: string = 'basal-metabolic-rate';

    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.basalMetabolicRate;
    }

    protected graphUnit: string = 'kcal';

    public render(): JSX.Element {
        return (
            <Panel
                id={this.panelId}
                width={500}
                height={305}
                title={this.panelTitle}
                icon={ICONS.QUESTION_MARK}
                popoverTitle={this.popoverTitle}
                popoverBody={this.popoverBody}
            >
                <div style={graphStyle.container}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={valueContainerStyle}>
                            <CurrentValue
                                value={this.currentValue}
                                unit={this.graphUnit}
                                valueFontSize={40}
                                unitFontSize={20}
                                decimalPlaces={0}
                            />
                            <ValueDelta
                                value={this.deltaValue}
                                marginLeft={-40}
                            />
                        </div>
                        <AreaGraph
                            width={300}
                            height={160}
                            dataPoints={this.graphDataPoints}
                            hasGrid={false}
                            dotRadius={5}
                            margin={{ top: 8, right: 30, left: 8, bottom: 0 }}
                            xAxisTickFormatter={this.generateXLabel}
                        />
                    </div>
                    {this.renderFullSummaryLink()}
                </div>
            </Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/dashboardPanels/BasalMetabolicRate.tsx